import { render } from "./DeletedProductsView.vue?vue&type=template&id=610d0942"
import script from "./DeletedProductsView.vue?vue&type=script&lang=js"
export * from "./DeletedProductsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__